import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { parseJWT } from "../../utils/jwtUtils";

import { MdOutlineLeaderboard } from "react-icons/md";

import { FaMoneyBillWave } from "react-icons/fa";
import { GiTwoCoins } from "react-icons/gi";
import { BsCashStack } from "react-icons/bs";
import { PiMedalFill } from "react-icons/pi";
import { MdSupportAgent } from "react-icons/md";

const HomePageFooter = () => {
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const userInfo = parseJWT(token?.token);

  const navigate = useNavigate();

  const [showFooter, setShowFooter] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        setShowFooter(false);
      } else {
        setShowFooter(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const footerMenus = [
    {
      title: "Wallet",
      amharic: "ዋሌት",
      icon: <FaMoneyBillWave size={20} />,
      onClick: () => navigate("/wallet"),
    },
    {
      title: "History",
      amharic: "መረጃ",
      icon: <BsCashStack size={20} />,
      onClick: () => navigate("/history"),
    },
    {
      title: "Contact",
      amharic: "አግኙን",
      icon: <GiTwoCoins size={20} />,
      onClick: () => window.open("https://t.me/bingo", "_blank"),
    },
    {
      title: "Profile",
      amharic: "ስለ እኛ",
      icon: <PiMedalFill size={22} />,
      onClick: () => navigate("/profile"),
      active: true,
    },
    {
      title: "Leaderboard",
      amharic: "መሪዎች",
      icon: <MdOutlineLeaderboard size={22} />,
      onClick: () => navigate("/leaderboard"),
    },
  ];

  return (
    <>
      {/* 🔻 Main Footer */}
      <div
        style={{
          transition: "transform 0.3s ease-in-out",
          transform: showFooter ? "translateY(0)" : "translateY(120%)",
        }}
        className="fixed bottom-1 left-0 right-0 z-50 block md:hidden"
      >
        <div
          className="
mx-auto
flex
w-[98%]
items-center
justify-between
gap-2

rounded-2xl

bg-gradient-to-r
from-[#0F172A]
via-[#1E293B]
to-[#273549]

border
border-slate-600

px-2
py-2

shadow-[0_12px_30px_rgba(0,0,0,.45)]
backdrop-blur-md
"
        >
          {footerMenus.map((item, index) => (
            <button
              key={index}
              onClick={item.onClick}
              className={`
                relative flex w-full flex-col items-center justify-center
                rounded-2xl px-1 py-2
                transition-all duration-300
                ${
                  item.active
                    ? "scale-105 border border-yellow-400/50 bg-gradient-to-b from-[#FACC15] to-[#EAB308] text-[#111827] shadow-[0_0_18px_rgba(250,204,21,.35)]"
                    : "bg-gradient-to-b from-[#1E293B] to-[#273549] text-slate-200 border border-transparent hover:from-[#26364A] hover:to-[#334155] hover:border-yellow-500/30 hover:text-white transition-all duration-300"
                }
              `}
            >
              {/* Icon */}
              <div
                className={`mb-1 ${
                  item.active ? "text-[#111827]" : "text-yellow-400"
                }`}
              >
                {item.icon}
              </div>

              {/* English */}
              <span className="text-[12px] font-semibold tracking-wide">
                {item.title}
              </span>

              {/* Amharic */}
              <span className="text-[10px] text-slate-300">{item.amharic}</span>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default HomePageFooter;
